import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const LanguageDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Language"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Language">
                {getFieldDecorator('language', {
                 initialValue: data.language,
                  rules: [{ required: true, message: 'Please input the Language!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default LanguageDialogForm;
